"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectToHomePage = exports.decodeToken = exports.redirectToLogin = exports.removeToken = exports.setToken = exports.getToken = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _jsonwebtoken = _interopRequireDefault(require("jsonwebtoken"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cookieDomainName = process.env.VUE_APP_COOKIE_DOMAIN_NAME;
var accessToken = 'AuthenticationToken';
var homePage = process.env.VUE_APP_HOMEPAGE_ROOT_URL || 'https://www.meinenghua.com';

var getToken = function getToken() {
  var cookieToken = _jsCookie["default"].get(accessToken);

  return cookieToken;
};

exports.getToken = getToken;

var setToken = function setToken(token) {
  if (cookieDomainName) {
    _jsCookie["default"].set(accessToken, token, {
      path: '/',
      domain: cookieDomainName
    });
  } else {
    _jsCookie["default"].set(accessToken, token);
  }
};

exports.setToken = setToken;

var removeToken = function removeToken() {
  if (cookieDomainName) {
    _jsCookie["default"].remove(accessToken, {
      path: '/',
      domain: cookieDomainName
    });
  } else {
    _jsCookie["default"].remove(accessToken);
  }
};

exports.removeToken = removeToken;

var redirectToLogin = function redirectToLogin() {
  window.location.href = "".concat(homePage, "/user/login?redirect=").concat(window.location.origin);
};

exports.redirectToLogin = redirectToLogin;

var decodeToken = function decodeToken() {
  var token = getToken();
  if (token) return _jsonwebtoken["default"].decode(token);
};

exports.decodeToken = decodeToken;

var redirectToHomePage = function redirectToHomePage() {
  window.location.href = homePage;
};

exports.redirectToHomePage = redirectToHomePage;